import React from 'react';
import Loading from '../../components/Loading';

const Loader = () => {
  return <Loading type="page" />;
};

export default Loader;
